import {useOktaAuth} from "@okta/okta-react";
import {useContext, useEffect} from "react";
import {FeatureFlagContext} from "./FeatureFlagProvider";
import log from "loglevel";

type OktaConfigProviderProps = {
  children: JSX.Element[] | JSX.Element;
};

const OktaConfigProvider = ({children}: OktaConfigProviderProps) => {
  const {oktaAuth} = useOktaAuth();
  const {oktaDevMode, oktaMaxClockSkew} = useContext(FeatureFlagContext);

  useEffect(() => {
    if (oktaAuth?.options) {
      log.debug(`OktaConfig - current options: ${JSON.stringify(oktaAuth.options)}`);
      if (oktaAuth.options.devMode != oktaDevMode) {
        log.debug(`OktaConfig - Updating Okta devMode=${oktaDevMode}`);
        oktaAuth.options.devMode = oktaDevMode;
        log.debug(`OktaConfig - Updated Okta devMode=${oktaAuth.options.devMode}`);
      }
      if (oktaAuth.options.maxClockSkew != oktaMaxClockSkew) {
        log.debug(`OktaConfig - Updating Okta maxClockSkew=${oktaMaxClockSkew}`);
        oktaAuth.options.maxClockSkew = oktaMaxClockSkew;
        log.debug(`OktaConfig - Updated Okta maxClockSkew=${oktaAuth.options.maxClockSkew}`);
      }
    }
  }, [oktaDevMode, oktaMaxClockSkew, oktaAuth]);

  return <>{children}</>;
};

export default OktaConfigProvider;
